import React from 'react';
import _ from 'lodash';
import { Button, Box, Stack, Typography, TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Paper, Checkbox } from '@mui/material';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { DebounceInput } from 'react-debounce-input';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { SmallFormDateField } from '../../../../../components/small-fields/SmallFormDateField';
import { AlertDialogContainer } from '../../../../../components/others/AlertDialogContainer';
import { submitEventAction } from '../../../../../services/request';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import { formatDate } from '../../../../../services/functions';

export const PLEventForm = props => {
  const { data, submitCallback, handleClose, allSeasons, allResorts, allAgeRanges, allCamps } = props;
  const { loading, mutate } = useMutation(submitEventAction);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
  const [activeCamps, setActiveCamps] = React.useState(data ? data.active_camps : []);

  const handleActiveCampsChange = value => {
    if (activeCamps.includes(value)) {
      setActiveCamps(prev => prev.filter(camp => camp !== value));
    } else {
      setActiveCamps(prev => [...prev, value]);
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('To pole nie może być puste'),
    season: Yup.string().required('To pole nie może być puste'),
    camps: Yup.array().min(1, 'Należy dodać conajmniej 1 turnus'),
    age_range: Yup.string().required('To pole nie może być puste'),
    birth_date_from: Yup.date().nullable()
      .required('To pole nie może być puste'),
    birth_date_to: Yup.date().nullable()
      .required('To pole nie może być puste')

  });
  const initialValues = {
    name: data ? data.name || '' : '',
    season: data ? data.season || '' : '',
    camps: data ? data.camps : [],
    slots: data ? data.camp_slot_dict : {},
    is_active: data ? data.is_active : true,
    resort: data ? data.resort || '' : '',
    birth_date_from: data ? data.birth_date_from || null : null,
    birth_date_to: data ? data.birth_date_to || null : null,
    age_range: data ? data.age_range || '' : '',
    canoeing_activities: data ? data.canoeing_activities : false
  };
  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, data ? 'PUT' : 'POST', data ? data.id : undefined);
    if (!error) {
      submitCallback(payload, data ? 'edit' : 'created', 'success', data ? 'Zaktualizowano imprezę' : 'Dodano nową imprezę', '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się ${data ? 'edytować' : 'dodać nowej'} imprezy`);
      setMessage('');
      setShowAlert(true);
    }
  };

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', data.id);
    if (!error) {
      submitCallback(data, 'delete', 'success', `Usunięto impreze ${data.name}`, '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się usunąć imprezy ${data.name}`);
      setMessage(payload);
      setShowAlert(true);
    }
  };

  const formik = useFormik({
    enableReinitialize: data ? true : false,
    initialValues,
    validationSchema,
    onSubmit: values => {
      values.active_camps = activeCamps;
      handleSubmit(values);
    }
  });

  const handleCampSlotsChange = (e, camp, idx) => {
    const slotsN = formik.values.slots;
    if (idx == 0) {
      slotsN[camp] = [e.target.value, !_.isNil(slotsN[camp][1]) ? slotsN[camp][1] : 0, !_.isNil(slotsN[camp][2]) ? slotsN[camp][2] : 0, !_.isNil(slotsN[camp][3]) ? slotsN[camp][3] : '', !_.isNil(slotsN[camp][4]) ? slotsN[camp][4] : ''];
    } else if (idx == 1) {
      slotsN[camp] = [!_.isNil(slotsN[camp][0]) ? slotsN[camp][0] : 0, e.target.value, !_.isNil(slotsN[camp][2]) ? slotsN[camp][2] : 0, !_.isNil(slotsN[camp][3]) ? slotsN[camp][3] : '', !_.isNil(slotsN[camp][4]) ? slotsN[camp][4] : ''];
    } else if (idx == 2) {
      slotsN[camp] = [!_.isNil(slotsN[camp][0]) ? slotsN[camp][0] : 0, !_.isNil(slotsN[camp][1]) ? slotsN[camp][1] : 0, e.target.value, !_.isNil(slotsN[camp][3]) ? slotsN[camp][3] : '', !_.isNil(slotsN[camp][4]) ? slotsN[camp][4] : ''];
    } else if (idx == 3) {
      slotsN[camp] = [!_.isNil(slotsN[camp][0]) ? slotsN[camp][0] : 0, !_.isNil(slotsN[camp][1]) ? slotsN[camp][1] : 0, !_.isNil(slotsN[camp][2]) ? slotsN[camp][2] : 0, e.target.value, !_.isNil(slotsN[camp][4]) ? slotsN[camp][4] : ''];
    } else {
      slotsN[camp] = [!_.isNil(slotsN[camp][0]) ? slotsN[camp][0] : 0, !_.isNil(slotsN[camp][1]) ? slotsN[camp][1] : 0, !_.isNil(slotsN[camp][2]) ? slotsN[camp][2] : 0, !_.isNil(slotsN[camp][3]) ? slotsN[camp][3] : '', e.target.value];

    }
    formik.setFieldValue('slots', slotsN);
  };

  const getLabel = camp => {
    const filteredCamp = _.filter(allCamps[formik.values.season], obj => {
      if (obj.value === camp) {
        return obj;
      }
    });

    if (filteredCamp.length > 0) {
      return filteredCamp[0].label;
    }

    return '';

  };
  console.log(formik.values.slots);

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <form onSubmit={formik.handleSubmit} style={{ textAlign: 'center' }}>
        <Stack direction="row" mt={1} p={1} spacing={2}>
          <Box display="flex" flexDirection="column" flex="1">
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Nazwa</Typography>
              <DebounceInput
                sx={{ flex: '1 1 90%' }}
                name="name"
                id="name"
                type="text"
                placeholder="nazwa imprezy"
                value={formik.values.name}
                onChange={formik.handleChange}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                debounceTimeout={100}
                element={SmallFormTextField}
                autoFocus
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Data urodzenia od</Typography>
              <SmallFormDateField
                sx={{ flex: '1 1 90%' }}
                name="birth_date_from"
                id="birth_date_from"
                type="text"
                placeholder="birth_date_from"
                value={formik.values.birth_date_from}
                onChange={val => formik.setFieldValue('birth_date_from', formatDate(val))}
                error={formik.touched.birth_date_from && Boolean(formik.errors.birth_date_from)}
                helperText={formik.touched.birth_date_from && formik.errors.birth_date_from}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Data urodzenia do</Typography>
              <SmallFormDateField
                sx={{ flex: '1 1 90%' }}
                name="birth_date_to"
                id="birth_date_to"
                type="text"
                placeholder="birth_date_to"
                value={formik.values.birth_date_to}
                onChange={val => formik.setFieldValue('birth_date_to', formatDate(val))}
                error={formik.touched.birth_date_to && Boolean(formik.errors.birth_date_to)}
                helperText={formik.touched.birth_date_to && formik.errors.birth_date_to}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Sezon</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 90%' }}
                select
                id="season"
                name="season"
                options={allSeasons}
                value={formik.values.season}
                onChange={e => {
                  formik.handleChange(e);
                  formik.setFieldValue('resort', '');
                  formik.setFieldValue('age_range', '');
                  formik.setFieldValue('camps', []);
                  setActiveCamps([]);
                  formik.setFieldValue('slots', {});
                }}
                error={formik.touched.season && Boolean(formik.errors.season)}
                helperText={formik.touched.season && formik.errors.season}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Ośrodek</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 90%' }}
                select
                id="resort"
                name="resort"
                options={allResorts[formik.values.season]}
                value={formik.values.resort}
                onChange={formik.handleChange}
                error={formik.touched.resort && Boolean(formik.errors.resort)}
                helperText={formik.touched.resort && formik.errors.resort}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Przedział wiekowy</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 90%' }}
                select
                id="age_range"
                name="age_range"
                options={allAgeRanges[formik.values.season]}
                value={formik.values.age_range}
                onChange={formik.handleChange}
                error={formik.touched.age_range && Boolean(formik.errors.age_range)}
                helperText={formik.touched.age_range && formik.errors.age_range}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Turnusy</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 90%' }}
                select
                multiple
                id="camps"
                name="camps"
                options={allCamps[formik.values.season]}
                value={formik.values.camps}
                onChange={e => {
                  const findRemovedCamp = formik.values.camps.filter(c => !e.target.value.includes(c));
                  const newActiveCamps = prev => [...prev, ...e.target.value.filter(c => !formik.values.camps.includes(c))];
                  if (_.isEmpty(findRemovedCamp)) {
                    setActiveCamps(newActiveCamps);
                  } else {
                    setActiveCamps(_.filter(newActiveCamps(activeCamps), c => c != findRemovedCamp[0]));

                  }
                  const slots = {};
                  e.target.value.forEach(element => {
                    if (formik.values.slots.hasOwnProperty(element)) {
                      slots[element] = formik.values.slots[element];
                    } else {
                      slots[element] = [0, 0, 0];
                    }
                  });
                  formik.setFieldValue('slots', slots);
                  formik.handleChange(e);
                }}
                error={formik.touched.camps && Boolean(formik.errors.camps)}
                helperText={formik.touched.camps && formik.errors.camps}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Aktywna</Typography>
              <Box sx={{ flex: '1 1 90%', width: '60%', maxWidth: '1200px' }} display="flex" justifyContent="flex-start">
                <Checkbox
                  id="is_active"
                  name="is_active"
                  checked={formik.values.is_active}
                  onChange={formik.handleChange}
                />
              </Box>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Udział w zajęciach kajakarskich</Typography>
              <Box sx={{ flex: '1 1 90%', width: '60%', maxWidth: '1200px' }} display="flex" justifyContent="flex-start">
                <Checkbox
                  id="canoeing_activities"
                  name="canoeing_activities"
                  checked={formik.values.canoeing_activities}
                  onChange={formik.handleChange}
                />
              </Box>
            </Stack>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Turnus</TableCell>
                    <TableCell align="center">Liczba miejsc</TableCell>
                    <TableCell align="center">Wartość brutto wariant 1 (zł)</TableCell>
                    <TableCell align="center">Godzina wariant 1</TableCell>
                    <TableCell align="center">Wartość brutto wariant 2 (zł)</TableCell>
                    <TableCell align="center">Godzina wariant 2</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formik.values.camps.map(camp => (
                    <TableRow
                      key={camp}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >

                      <TableCell align="center">
                        {getLabel(camp)}
                      </TableCell>
                      <TableCell align="center">
                        <DebounceInput
                          sx={{ flex: '1 1 90%' }}
                          name="slots"
                          id="slots"
                          type="text"
                          placeholder="liczba miejsc"
                          value={_.isNil(formik.values.slots[camp]) ? '' : !_.isNil(formik.values.slots[camp][0]) ? formik.values.slots[camp][0] : ''}
                          onChange={val => handleCampSlotsChange(val, camp, 0)}
                          error={formik.touched.slots && Boolean(formik.errors.slots)}
                          helperText={formik.touched.slots && formik.errors.slots}
                          debounceTimeout={100}
                          element={SmallFormTextField}
                          autoFocus
                        />
                      </TableCell>
                      <TableCell align="center">
                        <DebounceInput
                          sx={{ flex: '1 1 90%' }}
                          name="slots"
                          id="slots"
                          type="text"
                          placeholder="wartość brutto wariant 1 (zł)"
                          value={_.isNil(formik.values.slots[camp]) ? '' : !_.isNil(formik.values.slots[camp][1]) ? formik.values.slots[camp][1] : ''}
                          onChange={val => handleCampSlotsChange(val, camp, 1)}
                          error={formik.touched.slots && Boolean(formik.errors.slots)}
                          helperText={formik.touched.slots && formik.errors.slots}
                          debounceTimeout={100}
                          element={SmallFormTextField}
                          autoFocus
                        />
                      </TableCell>
                      <TableCell align="center">
                        <DebounceInput
                          sx={{ flex: '1 1 90%' }}
                          name="slots"
                          id="slots"
                          type="text"
                          placeholder="Godzina wariant 1"
                          value={_.isNil(formik.values.slots[camp]) ? '' : !_.isNil(formik.values.slots[camp][3]) ? formik.values.slots[camp][3] : ''}
                          onChange={val => handleCampSlotsChange(val, camp, 3)}
                          error={formik.touched.slots && Boolean(formik.errors.slots)}
                          helperText={formik.touched.slots && formik.errors.slots}
                          debounceTimeout={100}
                          element={SmallFormTextField}
                          autoFocus
                        />
                      </TableCell>
                      <TableCell align="center">
                        <DebounceInput
                          sx={{ flex: '1 1 90%' }}
                          name="slots"
                          id="slots"
                          type="text"
                          placeholder="wartość brutto wariant 2 (zł)"
                          value={_.isNil(formik.values.slots[camp]) ? '' : !_.isNil(formik.values.slots[camp][2]) ? formik.values.slots[camp][2] : ''}
                          onChange={val => handleCampSlotsChange(val, camp, 2)}
                          error={formik.touched.slots && Boolean(formik.errors.slots)}
                          helperText={formik.touched.slots && formik.errors.slots}
                          debounceTimeout={100}
                          element={SmallFormTextField}
                          autoFocus
                        />
                      </TableCell>
                      <TableCell align="center">
                        <DebounceInput
                          sx={{ flex: '1 1 90%' }}
                          name="slots"
                          id="slots"
                          type="text"
                          placeholder="Godzina wariant 2"
                          value={_.isNil(formik.values.slots[camp]) ? '' : !_.isNil(formik.values.slots[camp][4]) ? formik.values.slots[camp][4] : ''}
                          onChange={val => handleCampSlotsChange(val, camp, 4)}
                          error={formik.touched.slots && Boolean(formik.errors.slots)}
                          helperText={formik.touched.slots && formik.errors.slots}
                          debounceTimeout={100}
                          element={SmallFormTextField}
                          autoFocus
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Stack>
            <Typography variant="subtitle2">Aktywne turnusy</Typography>
            {formik.values.camps.map(campValue => {

              const camp = allCamps[formik.values.season].find(item => item.value === campValue);

              if (_.isNil(camp)) {
                return null;
              }

              return (
                <Stack key={camp.value} direction="row" alignItems="center">
                  <Checkbox
                    checked={activeCamps.includes(camp.value)}
                    onChange={() => handleActiveCampsChange(camp.value)}
                  />
                  <Typography>{camp.label}</Typography>
                </Stack>
              );
            })}
          </Stack>
        </Stack>

        <Button
          color="primary"
          variant="contained"
          type="submit"
          sx={{ mt: 3 }}
          disabled={loading}
        >
          <AddIcon />
          Zapisz
        </Button>
        { data
          ? <Button
            color="error"
            variant="contained"
            sx={{ mt: 3, ml: 4 }}
            onClick={() => {
              setConfirmDeleteOpen(true);
            }}
            disabled={loading}
          >
            <DeleteIcon />
          Usuń
          </Button>
          : null}
      </form>
      <ConfirmDialog
        title="Usunąć Imprezę?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDelete}
        disabled={loading}
      >
        Czy na pewno chcesz usunąć tą imprezę?
      </ConfirmDialog>
    </>

  );
};
